"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var bind_1 = require("@reverbdotcom/commons/dist/bind");
var SocialLink = /** @class */ (function (_super) {
    tslib_1.__extends(SocialLink, _super);
    function SocialLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SocialLink.prototype.trackClick = function () {
        tracker_1.trackInteraction({
            componentName: 'SocialLink',
            type: 'socialLinks',
            url: this.props.link,
        });
    };
    SocialLink.prototype.icon = function () {
        return this.props.icon || this.props.type;
    };
    SocialLink.prototype.render = function () {
        return (React.createElement("a", { href: this.props.link, onClick: this.trackClick, target: "_blank", rel: "noopener noreferrer" },
            React.createElement("span", { className: "share-" + this.props.type + " no-icon-bg" },
                React.createElement("span", { className: "fa fa-" + this.icon() }))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], SocialLink.prototype, "trackClick", null);
    return SocialLink;
}(React.Component));
exports.default = SocialLink;
//# sourceMappingURL=social_link.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/shared/social_link.js
// module id = BNa7
// module chunks = 20 21